import React, { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import "./ContactPage.css";
import SendIcon from "@mui/icons-material/Send";
import EmailIcon from "@mui/icons-material/Email";

const ContactPage: React.FC = () => {
  const { t, language } = useLanguage();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Create a mailto link with the form data
    const mailtoLink = `mailto:arzeichessed@gmail.com?subject=${encodeURIComponent(
      subject,
    )}&body=${encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`,
    )}`;

    window.location.href = mailtoLink;
    setSubmitted(true);

    // Reset form after submission
    setName("");
    setEmail("");
    setSubject("");
    setMessage("");
  };

  // Helper function to get the appropriate label based on language
  const getLabel = (hebrewText: string, englishKey: string) => {
    return language === "he" ? hebrewText : t(englishKey);
  };

  return (
    <div className="contact-page">
      <h1 className="contact-page-title">{t("contact.us")}</h1>

      <div className="contact-content">
        <div className="contact-form-section">
          {submitted ? (
            <div className="success-message">
              <p>{t("message.sent")}</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">{getLabel("שם מלא", "your.name")}</label>
                <input
                  id="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  placeholder={getLabel("הכנס את שמך המלא", "name.placeholder")}
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">
                  {getLabel("כתובת מייל", "your.email")}
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder={getLabel(
                    "הכנס את כתובת המייל שלך",
                    "email.placeholder",
                  )}
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">
                  {getLabel("נושא", "email.subject")}
                </label>
                <input
                  id="subject"
                  type="text"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  required
                  placeholder={getLabel(
                    "הכנס נושא להודעה",
                    "subject.placeholder",
                  )}
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">
                  {getLabel("תוכן ההודעה", "email.message")}
                </label>
                <textarea
                  id="message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                  rows={6}
                  placeholder={getLabel(
                    "הכנס את תוכן ההודעה כאן",
                    "message.placeholder",
                  )}
                />
              </div>

              <button type="submit" className="send-button">
                <SendIcon />
                <span>{getLabel("שלח", "email.send")}</span>
              </button>
            </form>
          )}
        </div>

        <div className="contact-info-section">
          <div className="contact-methods">
            <div className="contact-method">
              <div className="contact-icon">
                <EmailIcon />
              </div>
              <div className="contact-details">
                <h3>{getLabel("דוא״ל", "email")}</h3>
                <p>arzeichessed@gmail.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
